<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectOneInput
        :question="$t('cooling')"
        :image="require('@/assets/cooling.jpeg')"
        :selections="[
          {
            name: $t('select-questions.yes'),
            value: 'yes'
          },
          {
            name: $t('select-questions.optional'),
            value: 'optional'
          },
          {
            name: $t('select-questions.no'),
            value: 'no'
          }
        ]"
        :selected-value="selected"
        :clicked-callback="onSelect"
      ></SelectOneInput>
      <a @click="$router.push(getPrevStepUrl(step, $i18n.locale))" class="back-btn"
      >{{ $t('back') }}</a
      >
    </div>
  </div>
</template>

<script>
  import SelectOneInput from "../../components/SelectOneInput";
  import {mapMutations} from "vuex";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getStepIndex} from "@/utils/steps.js";
  import {getPrevStepUrl, goToNextStep, redirectToUnselectedStepIfAny} from "../../utils/steps";

  export default {
  name: "Lighting",
  components: { CalculatorHeading, SelectOneInput },
  data() {
    return {
      step: getStepIndex("cooling"),
      getPrevStepUrl: getPrevStepUrl,
      selected: this.$store.state.data.cooling
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateCooling"]),
    onSelect(value) {
      this.selected = value;
      this.updateCooling(value);
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/_variables.scss";
h4 {
  color: $color-primary;
}
.back-btn {
  margin-top: 60px;
}
</style>
